module.exports = "/content/8808a9b4c820fd723d7411f6bbb18d7a.png";